function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M6 0.5L0 5.1V13.5H1V12.2V5.6L6 1.8L11 5.6V12.5H8V7.5H4V12.5H2V13.5H4H5V12.5V8.5H7V12.5V13.5H8H12V5.1L6 0.5Z",
  fill: "#10CFAB"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 12,
  height: 13,
  fill: "white",
  transform: "translate(0 0.5)"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/home.0a078c0e.svg";
export { SvgComponent as ReactComponent };